import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  syncButton: {
    margin: '0 15px',
    width: '90%',
    color: theme.scenes.textColor,
  },
}))

export default useStyles
